namespace GeniuzPOS.ReportMasterData {
    export interface Report_1104Row {
        SupplId?: string;
        SupplName?: string;
        ShortName?: string;
        ContactName?: string;
        SupTelNo?: string;
        SupplRegName?: string;
        SupplTaxId?: string;
        SupplAddress?: string;
        SupplType?: number;
        ConsignFg?: number;
    }

    export namespace Report_1104Row {
        export const idProperty = 'SupplId';
        export const nameProperty = 'SupplId';
        export const localTextPrefix = 'ReportMasterData.Report_1104';
        export const deletePermission = '1POSBASE:รายงาน:ทะเบียน:ผู้จำหน่าย:View';
        export const insertPermission = '1POSBASE:รายงาน:ทะเบียน:ผู้จำหน่าย:View';
        export const readPermission = '1POSBASE:รายงาน:ทะเบียน:ผู้จำหน่าย:View';
        export const updatePermission = '1POSBASE:รายงาน:ทะเบียน:ผู้จำหน่าย:View';

        export declare const enum Fields {
            SupplId = "SupplId",
            SupplName = "SupplName",
            ShortName = "ShortName",
            ContactName = "ContactName",
            SupTelNo = "SupTelNo",
            SupplRegName = "SupplRegName",
            SupplTaxId = "SupplTaxId",
            SupplAddress = "SupplAddress",
            SupplType = "SupplType",
            ConsignFg = "ConsignFg"
        }
    }
}
